'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var safeFetch = require('../../utils/safeFetch.js');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var Autocomplete = _interopDefault(require('@material-ui/lab/Autocomplete'));
var KeyboardArrowDownIcon = _interopDefault(require('@material-ui/icons/KeyboardArrowDown'));
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var AsyncSelectWithTopLabel = function (props) {
    var _a = props.defaultValue, defaultValue = _a === void 0 ? null : _a, _b = props.disableClearable, disableClearable = _b === void 0 ? false : _b, _c = props.disabled, disabledInput = _c === void 0 ? false : _c, _d = props.error, error = _d === void 0 ? false : _d, fetchData = props.fetchData, _e = props.placeholder, placeholder = _e === void 0 ? '' : _e, reporter = props.reporter, title = props.title;
    var _f = React.useState(false), open = _f[0], setOpen = _f[1];
    var _g = React.useState([]), options = _g[0], setOptions = _g[1];
    var _h = React.useState(defaultValue), selected = _h[0], setSelected = _h[1];
    var loading = open && options.length === 0;
    var onChange = function (event, value) {
        setSelected(value);
        reporter(event, value);
    };
    React.useEffect(function () {
        if (!loading)
            return undefined;
        return safeFetch(fetchData, setOptions);
    }, [loading]);
    React.useEffect(function () {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    return (React__default.createElement(styledComponents.Main, null,
        typeof title === 'string' && title.length > 0 && (React__default.createElement(SmallDarkText, { "data-testid": 'async-select-title' }, title)),
        React__default.createElement(Autocomplete, { id: 'asynchronous-select', open: open, disabled: disabledInput, onOpen: function () {
                setOpen(true);
            }, onClose: function () {
                setOpen(false);
            }, getOptionSelected: function (option, value) { return option.display === value.display; }, getOptionLabel: function (option) { return option.display; }, disableClearable: disableClearable, options: options, loading: loading, popupIcon: React__default.createElement(KeyboardArrowDownIcon, null), value: selected, onChange: onChange, renderOption: utils.getRenderOption, getOptionDisabled: function (option) { return option.disabled || false; }, renderInput: function (params) {
                return (React__default.createElement(styledComponents.StyledTextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                , tslib.__assign({}, params, { error: error, placeholder: placeholder, variant: 'outlined', disabled: disabledInput, InputProps: tslib.__assign(tslib.__assign({}, params.InputProps), { endAdornment: (React__default.createElement(React__default.Fragment, null,
                            loading ? React__default.createElement(CircularProgress, { color: 'inherit', size: 17 }) : null,
                            params.InputProps.endAdornment)) }) })));
            } })));
};

module.exports = AsyncSelectWithTopLabel;
